import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import Banner from 'components/banner/Banner'
import bannerImage1 from 'assets/images/suggest-slider1.jpg'
import Card from "components/cards/Card"
import { Typography, CardContent, CardHeader, Grid, OutlinedInput, TextField, Button, MenuItem, CircularProgress, Snackbar }from "@material-ui/core"
import { Alert } from '@material-ui/lab'
import causesData from 'testdata/causesData'
import { callPostApiWithAuth } from 'utils/api'

export default function SuggestPage () {
  const classes = useStyles()
  const [slides, setSlides] = useState(undefined)
  const [causesListOptions, setCausesListOptions] = useState(undefined)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState({
    open: false,
    severity: '',
    message: ''
  })
  const [validationErros, setValidationErrors] = useState({
    company_name: '',
    website: '',
    description: '',
    cause: '',
    note: '',
  })
  const [formData, setFormData] = useState({
    company_name : '',
    website : '', 
    description: '',
    cause : '',
    note : '',
  })

  useEffect(() => {
    setSlides([
      {
        image: bannerImage1,
        title: 'Together we can change the world.',
      },
    ])
  }, [])

  useEffect(() => {
    let causesListOptions_ = []
    if (causesData.length > 0) {
      for (let i = 0; i < causesData.length; i ++) {
        causesListOptions_ = [
          ...causesListOptions_,
          {
            value: causesData[i].id,
            key: i + 1,
            label: causesData[i].shortTitle,
          },
        ]
      }
    }
    setCausesListOptions(causesListOptions_)
  }, [causesData])

  const handleSubmit = () => {
    if (validateFormData()) return
    setIsSubmitting(true)
    callPostApiWithAuth('suggestion', formData, onSuccessSubmit, onFailedSubmit)
  }

  const onSuccessSubmit = (data) => {
    setIsSubmitting(false)
    setMessage({
      open: true,
      severity: 'success',
      message: "Suggest has been successfully uploaded"
    })
  }

  const onFailedSubmit = (err) => {
    setIsSubmitting(false)
    setMessage({
      open: true,
      severity: 'error',
      message: err.message
    })
  }

  const validateFormData = () => {
    let validationResult = false
    let validationErros_ = {
      company_name: '',
      website: '',
      description: '',
      cause: '',
      note: '',
    }
    if (!formData) return true
    if (formData.company_name == '') {
      validationErros_ = ({
        ...validationErros_,
        company_name: 'Please enter company name',
      })
      validationResult = true
    }
    if (formData.website == '') {
      validationErros_ = ({
        ...validationErros_,
        website: 'Please enter website url',
      })
      validationResult = true
    }
    if (formData.note == '') {
      validationErros_ = ({
        ...validationErros_,
        note: 'Please enter note',
      })
      validationResult = true
    }
    if (formData.cause == '') {
      validationErros_ = ({
        ...validationErros_,
        cause: 'Please enter cause',
      })
      validationResult = true
    }
    if (formData.description == '') {
      validationErros_ = ({
        ...validationErros_,
        description: 'Please enter description',
      })
      validationResult = true
    }
    setValidationErrors(validationErros_)
    return validationResult
  }

  return (
    <div className={classes.container}>
      <Banner slides={slides} />
      <Card className={classes.companyInfoCardView}>
        <CardHeader title="Company Infomation" />
        <CardContent className={classes.cardContent}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography 
                className={classes.outlinedInputLable} 
                component={'h2'}
              >
                Company Name
              </Typography>
              <OutlinedInput 
                className={classes.inputField}
                placeholder="Company of Name"
                value={formData?.company_name}
                onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
              />
              <Typography 
                className={classes.validationErrorLabel} 
                component={'h3'}
              >
                {validationErros?.company_name}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography 
                className={classes.outlinedInputLable} 
                component={'h2'}                
              >
                Website URL
              </Typography>
              <OutlinedInput 
                className={classes.inputField}
                placeholder="Company Website"
                value={formData?.website}
                onChange={(e) => setFormData({ ...formData, website: e.target.value })}
              />
              <Typography 
                className={classes.validationErrorLabel} 
                component={'h3'}
              >
                {validationErros?.website}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography 
                className={classes.outlinedInputLable} 
                component={'h2'}                
              >
                Description
              </Typography>
              <TextField
                multiline
                rows={4}
                variant="outlined"
                className={classes.textAreaField}
                value={formData?.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
              <Typography 
                className={classes.validationErrorLabel} 
                component={'h3'}
              >
                {validationErros?.description}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <Typography 
                className={classes.outlinedInputLable} 
                component={'h2'}                
              >
                Causes
              </Typography>
              <TextField
                select
                variant="outlined"
                className={classes.selectOption}
                value={formData?.cause}
                onChange={(e) => setFormData({ ...formData, cause: e.target.value })}
              >
                {causesListOptions && causesListOptions.map((causesListOption) => (
                  <MenuItem key={causesListOption.key} value={causesListOption.value}>
                    {causesListOption.label}
                  </MenuItem>
                ))}
              </TextField>
              <Typography 
                className={classes.validationErrorLabel} 
                component={'h3'}
              >
                {validationErros?.cause}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={3} className={classes.gridContent}>
            <Grid item xs={12}>
              <Typography 
                className={classes.outlinedInputLable} 
                component={'h2'}                
              >
                How did you hear about them?
              </Typography>
              <TextField
                multiline
                rows={4}
                variant="outlined"
                className={classes.textAreaField} 
                value={formData?.note}
                onChange={(e) => setFormData({ ...formData, note: e.target.value })}
              />
              <Typography 
                className={classes.validationErrorLabel} 
                component={'h3'}
              >
                {validationErros?.note}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.submitButtonGrid}>
              <Button
                className={classes.submitButton}
                variant="contained"
                onClick={handleSubmit}
              >
                {isSubmitting && (
                  <CircularProgress
                    color={'primary'}
                    size={24}
                  />
                )}
                Submit
              </Button>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                open={message.open}
                autoHideDuration={2000}
                onClose={(e, r) => {
                  if (r == 'timeout') setMessage({
                    open: false,
                    severity: '',
                    message: '',
                  })
                }}
              >
                <Alert
                  severity={message?.severity}
                  variant='filled'
                  onClose={() => setMessage({
                    open: false,
                    severity: '',
                    message: '',
                  })}
                >
                  {message?.message}
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    minHeight: 400,    
  },
  gridContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  companyInfoCardView: {
    marginTop: 24,
    '& span, h2' : {
      fontFamily: 'Proxima Nova, sans-serif !important',
    },
    '& .MuiCardHeader-root': {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      border: 'unset',
    },
    '& .MuiCardContent-root:first-child': {
      padding: '24px !important',
    },
  },
  cardContent: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
  },
  inputField: {
    width: '100%',
    height: 36,
    background: '#F9F9F9',
    fontSize: 14,
    fontFamily: 'Proxima Nova, sans-serif !important',
  },
  outlinedInputLable: {
    marginBottom: 10,
    fontSize: 14,
  },
  textAreaField: {
    width: '100%',
    background: '#F9F9F9',
    '& textarea': {
      fontFamily: 'Proxima Nova, sans-serif !important',
    },
  },
  selectOption: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      height: 36,
      background: '#F9F9F9',
    },
    '& :focus': {
      background: 'none',
    }
  },
  submitButtonGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButton: {
    width: '250px',
    backgroundColor: `${theme.palette.primary.primaryButton} !important`,
    color: `${theme.palette.primary.primaryButtonLabel} !important`,
  },
  validationErrorLabel: {
    fontFamily: 'Proxima Nova, sans-serif !important',
    fontSize: 12,
    color: '#FF6E6E',
  },
}))